import React, { useEffect, useState, useCallback } from "react";
import UpdateUser from "./UpdateUser";
import {
  updateUserAction,
  UPDATE_USER_INIT,
  myInfoAction,
  updateAddressAction,
  updateAddressInit
} from "../actionCreators";
import { getFormValues, reset } from "redux-form";
import { useDispatch, connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SUCCESS } from "../../../common/constants/commonConstant";

const UpdateUserContainer = ({ values }) => {
  const [error, setError] = useState(null);
  const [addressInput, setAddressInput] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    isUpdatedUser,
    updateUserErrorReason,
    myInfo,
    isUpdatingAddress,
    isAddressUpdated,
    updateAddressError
  } = useSelector(state => state.updateUserReducer);

  // 진입 시 본인 정보 1회 조회
  useEffect(() => {
    dispatch(myInfoAction());
  }, [dispatch]);

  // 본인 정보 수신 시 주소 입력 칸 초기값 채움
  useEffect(() => {
    if (myInfo) {
      setAddressInput(myInfo.address || "");
    }
  }, [myInfo]);

  const onSubmit = e => {
    const { oldPassword, password } = values;
    dispatch(updateUserAction({ oldPassword, password }));
  };

  const onClickCancel = useCallback(
    e => {
      navigate("/");
    },
    [navigate]
  );

  const onChangeAddress = useCallback(value => {
    setAddressInput(value);
  }, []);

  const onSaveAddress = useCallback(() => {
    dispatch(updateAddressAction({ address: addressInput }));
  }, [addressInput, dispatch]);

  // 비밀번호 변경 성공 — 주소 저장과 동일하게 인라인 메시지 표시 후 자동 사라지게 init
  // 폼도 비움: 남겨두면 성공 직후 재제출 시 이미 바뀐 비밀번호가 oldPassword 로 다시 전송됨.
  useEffect(() => {
    if (isUpdatedUser) {
      setError(null);
      dispatch(reset("UpdateUserForm"));
      const t = setTimeout(() => dispatch({ type: UPDATE_USER_INIT }), 2500);
      return () => clearTimeout(t);
    }
  }, [isUpdatedUser, dispatch]);

  // 비밀번호 변경 실패
  useEffect(() => {
    if (updateUserErrorReason !== null && updateUserErrorReason !== "") {
      if (SUCCESS !== updateUserErrorReason.retCode) {
        setError(`${updateUserErrorReason.userMsg}`);
      }
    }
  }, [updateUserErrorReason]);

  // 주소 저장 성공 시 본인 정보 재조회 후 메시지 자동 사라지게 init
  useEffect(() => {
    if (isAddressUpdated) {
      dispatch(myInfoAction());
      const t = setTimeout(() => dispatch(updateAddressInit()), 2500);
      return () => clearTimeout(t);
    }
  }, [isAddressUpdated, dispatch]);

  return (
    <UpdateUser
      onSubmit={onSubmit}
      error={error}
      isUpdatedUser={isUpdatedUser}
      onClickCancel={onClickCancel}
      myInfo={myInfo}
      addressInput={addressInput}
      onChangeAddress={onChangeAddress}
      onSaveAddress={onSaveAddress}
      isUpdatingAddress={isUpdatingAddress}
      isAddressUpdated={isAddressUpdated}
      addressError={updateAddressError}
    />
  );
};

export default connect(state => ({
  values: getFormValues("UpdateUserForm")(state)
}))(UpdateUserContainer);
